/* eslint-disable */

import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import { useRouter } from "@core/utils/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import { GetPagingParams as getList } from "@/services/api/HoSoCanBoCongChuc/DanhMuc/TrangThaiNghiViecService";

import { unGroupList } from "@/userlibs/globalLibs";

export default function useDonViService() {
  const toast = useToast();
  const { route, router } = useRouter();

  const getDataList = (ctx, callback) => {
    getList().then((response) => {
      if (!response.isError) {
        callback(response.data["data"]);
      } else {
        callback(null);
        toast({
          component: ToastificationContent,
          props: {
            title: "Thất bại",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: response.message,
          },
        });
      }
    });
  };

  return {
    getDataList,
  };
}
